import { ApolloError } from 'apollo-boost';
export const isGraphQLError = (error) => {
    return !!error && typeof error === 'object' && 'message' in error && typeof error.message === 'string';
};
export const isGraphQLErrorArray = (error) => {
    return Array.isArray(error) && error.length > 0 && isGraphQLError(error[0]);
};
export const isApolloError = (error) => {
    return error instanceof ApolloError;
};
export const isApolloGraphQLError = (error) => {
    return isApolloError(error) && Array.isArray(error.graphQLErrors) && error.graphQLErrors.length > 0;
};
export const isApolloNetworkError = (error) => {
    return isApolloError(error) && error.networkError && typeof error.networkError.message === 'string';
};
export const isStringError = (error) => {
    return typeof error === 'string';
};
export const isStringErrorArray = (error) => {
    return Array.isArray(error) && typeof error[0] === 'string';
};
export const isServerError = (error) => {
    return 'statusCode' in error;
};
